<avi-toast
    [type]="notificationType"
    header="{{ cloudName }}"
    [actions]="actions"
    (onClose)="handleClose()"
>
    {{ status }}
</avi-toast>
